import React from "react";
import { range } from "../../lib/utils";
import { MAX_MISTAKES } from "../../lib/constants";
import { GameStatusContext } from "../../providers/GameStatusProvider";

function NumberOfMistakesDisplay() {
  const { numMistakesUsed } = React.useContext(GameStatusContext);
  // array size of number of guess. [1, 2, 3, 4]
  const mistakeRange = range(MAX_MISTAKES);
  const mistakesRemaining = MAX_MISTAKES - numMistakesUsed;

  return (
    <div className="flex items-center justify-center gap-2">
      <span className="text-[#6B7F5E] tracking-wide">Mistakes remaining:</span>
      <div className="flex gap-2">
        {mistakeRange.map((el) => (
          <div
            key={el}
            className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
              el < mistakesRemaining
                ? 'bg-gradient-to-br from-[#9CA986] to-[#6B7F5E] shadow-md'
                : 'bg-[#D4D9CE]/50'
            }`}
          />
        ))}
      </div>
    </div>
  );
}

export default NumberOfMistakesDisplay;
